<template>
  <div>
    <!-- <div class="toolsb">
      <el-input class="mb-input" placeholder="请输入证书编号" v-model="certificateNo"></el-input>
      <el-button type="primary" @click="toQuery">搜索</el-button>
      <el-button type="primary" @click="resetQuery">重置</el-button>
    </div> -->
    <el-table :data="tableDataCertificate" tooltip-effect="dark" :stripe="true"
      :header-cell-style="tableHeaderCellStyle">
      <el-table-column prop="certificateNo" label="证书编号" align="center"></el-table-column>
      <el-table-column prop="templateName" label="证书标题" align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button v-show="scope.row.receiveFlag" type="text" disabled>已领取</el-button>
          <el-button v-show="!scope.row.receiveFlag" type="text" v-on:click="receiveTap(scope.$index, scope.row)">领取
          </el-button>
          <el-button type="text" v-on:click="previewTap(scope.$index, scope.row)">查看证书</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="mb-pagination" :current-page="curPage" layout="total, prev, pager, next" :total="total"
      @current-change="handleCurrentChange"></el-pagination>
  </div>
</template>

<script>
  import CommonStyle from "@/utils/CommonStyle";
  export default {
    name: "StudentCertificate",
    data () {
      return {
        tableHeaderCellStyle: CommonStyle.tableHeaderCellStyle,
        certificateNo: "",
        tableDataCertificate: [],
        total: 0,
        curPage: 1
      };
    },
    mounted () {
      this.certificateList(this);
    },
    methods: {
      toQuery () {
        this.certificateList(this, 1);
      },
      resetQuery () {
        this.certificateNo = "";
        this.certificateList(this, 1);
      },
      certificateList (that, curPage) {
        let _userInfo = that.$store.state.user.userInfo;
        that.HttpConnection.get(`/certificate/listById/${_userInfo.userId}`, {
          params: {
            pageSize: 10,
            pageNum: curPage,
            certificateNo: that.certificateNo
          }
        }).then(function (response) {
          that.tableDataCertificate = response.rows;
          that.total = response.total;
        });
      },
      handleCurrentChange (val) {
        this.curPage = val;
        this.certificateList(this, val);
      },
      receiveTap (index, row) {
        let that = this;
        that.HttpConnection.post(`/certificate/receive/${row.certificateId}`).then(function (response) {
          that.$message({
            type: "success",
            message: "领取成功"
          });
          that.certificateList(that, that.curPage);
        });
      },
      previewTap (index, row) {
        console.log(row.url);
        window.open(process.env.VUE_APP_imagePath + row.url, "_blank");
      }
    }
  };
</script>

<style scoped lang="scss">
</style>